import { createSlice } from '@reduxjs/toolkit';
import ASYNC_STATE from '../../../constants/AsyncState';
import { byId } from '../../../helper/byKey';
import { getErrorMsg } from '../../../helper/errorMessages';
import paginateReducer from '../../../helper/reduxPaginationHelper';
import { fetchTenantDetails, fetchTenantSelectOptions, fetchTenants } from './tenantsThunks';

const asyncState = {
  fetch: {
    status: ASYNC_STATE.IDLE,
    errorMessage: null,
  },
  fetchTenantDetails: {
    status: ASYNC_STATE.IDLE,
    errorMessage: null,
  },
};

const initialState = {
  ...asyncState,
  tenants: {},
  selectedTenantId: undefined,
  tenantSelectOptions: [],
};

const tenantsSlice = createSlice({
  name: 'tenants',
  initialState,
  reducers: {
    tenantSelected: (state, action) => {
      const { tenantId } = action.payload;
      state.selectedTenantId = tenantId;
    },
    tenantSelectionReset: (state) => {
      state.selectedTenantId = undefined;
    },
  },
  extraReducers: {
    [fetchTenants.pending]: (state) => {
      state.fetch.status = ASYNC_STATE.LOADING;
    },
    [fetchTenants.fulfilled]: paginateReducer(
      (state) => state.fetch,
      (state, action) => {
        const { data } = action.payload;
        state.fetch.status = ASYNC_STATE.SUCCEEDED;
        state.tenants = { ...byId(data) };
      },
    ),
    [fetchTenants.rejected]: (state, action) => {
      const { error } = action.error;
      state.fetch.status = ASYNC_STATE.FAILED;
      state.fetch.error = error;
      state.fetch.errorMessage = getErrorMsg('default');
    },
    [fetchTenantDetails.pending]: (state) => {
      state.fetchTenantDetails.status = ASYNC_STATE.LOADING;
    },
    [fetchTenantDetails.fulfilled]: (state, action) => {
      const { tenant } = action.payload;
      const { id } = tenant;
      state.fetchTenantDetails.status = ASYNC_STATE.SUCCEEDED;
      state.selectedTenantId = id;
      state.tenants[id] = tenant;
    },
    [fetchTenantDetails.rejected]: (state, action) => {
      const { error } = action.error;
      state.fetchTenantDetails.status = ASYNC_STATE.FAILED;
      state.fetchTenantDetails.error = error;
      state.fetchTenantDetails.errorMessage = getErrorMsg('default');
    },
    [fetchTenantSelectOptions.fulfilled]: (state, action) => {
      state.tenantSelectOptions = action.payload;
    },
  },
});

export const { tenantSelected, tenantSelectionReset } = tenantsSlice.actions;

export default tenantsSlice.reducer;
